<form [formGroup]="form" nz-row [nzGutter]="24">
  <nz-divider nzText="Textos trocáveis"></nz-divider>

  <nz-table
    [nzData]="[1]"
    [nzFrontPagination]="false"
    nzFooter="{{ customTextReplacements.controls.length }} textos trocáveis cadastrados"
    nzBordered
    nzSize="small"
    formArrayName="customTextReplacements"
    style="width: 100%">
    <thead>
      <tr>
        <th>#</th>
        <th>Arquivos</th>
        <th>De</th>
        <th>Para</th>
        <th style="text-align: center">Ações</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let data of customTextReplacements.controls; let i = index">
        <ng-container *ngIf="editCache?.rowId !== data.controls.id.value; else editTemplate">
          <td>{{ i + 1 }}</td>
          <td nzBreakWord>{{ data.controls.file.value }}</td>
          <td nzBreakWord>{{ data.controls.from.value }}</td>
          <td nzBreakWord>{{ data.controls.to.value }}</td>
          <td style="text-align: center">
            <ng-container *ngIf="data.controls.isEditable.value">
              <button nz-button nzType="text" nz-tooltip="Editar texto trocável" (click)="startEdit(data.controls.id.value, $any(data))">
                <i nz-icon nzType="edit"></i>
              </button>

              <nz-divider nzType="vertical"></nz-divider>

              <button
                nz-button
                nzType="text"
                nz-tooltip="Excluir texto trocável"
                nz-popconfirm
                nzPopconfirmTitle="Tem certeza que deseja remover?"
                (nzOnConfirm)="removeTextReplacement(i)">
                <i nz-icon nzType="delete"></i>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-template #editTemplate>
          <td>{{ i + 1 }}</td>
          <td><input type="text" nz-input [(ngModel)]="editCache.data.file" [ngModelOptions]="{ standalone: true }" /></td>
          <td><input type="text" nz-input [(ngModel)]="editCache.data.from" [ngModelOptions]="{ standalone: true }" /></td>
          <td><input type="text" nz-input [(ngModel)]="editCache.data.to" [ngModelOptions]="{ standalone: true }" /></td>
          <td style="text-align: center">
            <button nz-button nzType="link" (click)="saveEdit($any(data))" nz-tooltip="Salvar edição">
              <i nz-icon nzType="save"></i>
            </button>

            <nz-divider nzType="vertical"></nz-divider>

            <button nz-button nzType="link" [nzDanger]="true" (click)="cancelEdit()" nz-tooltip="Cancelar edição">
              <i nz-icon nzType="close"></i>
            </button>
          </td>
        </ng-template>
      </tr>

      <tr>
        <td colspan="5" style="text-align: center">
          <button nz-button nzType="primary" (click)="addTextReplacement()">
            <i nz-icon nzType="plus"></i>
            Adicionar
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</form>
